var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var displayName = 'AccessibilityHelper';
export var AccessibilityHelper = function (_a) {
    var ariaDescribedbyId = _a.ariaDescribedbyId, instructionText = _a.instructionText, instructionUpdates = _a.instructionUpdates;
    return (_jsxs("div", __assign({ "data-id": "AccessibilityHelper" }, { children: [_jsx("span", __assign({ id: ariaDescribedbyId, style: { display: 'none' } }, { children: instructionText })), _jsx("span", __assign({ role: "status", "aria-live": "polite", style: {
                    position: 'absolute',
                    padding: '0px',
                    border: '0px',
                    height: '1px',
                    width: '1px',
                    marginBottom: '-1px',
                    marginRight: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0px 0px 0px 0px)',
                    whiteSpace: 'nowrap',
                } }, { children: instructionUpdates }))] })));
};
AccessibilityHelper.displayName = displayName;
